import type { Article } from '@/mocks/articles';

interface ArticleSchemaProps {
  article: Article;
}

export default function ArticleSchema({ article }: ArticleSchemaProps) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.excerpt,
    image: article.imageUrl,
    author: {
      '@type': 'Person',
      name: article.author,
    },
    datePublished: article.publishDate,
    publisher: {
      '@type': 'Organization',
      name: '黑料爆料',
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `https://heiliaobaoliao.com/article/${article.id}`,
    },
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}